export class BestStreetName{
    items: Array<BestStreetNameItem>;
    hasMore: boolean;
    limit: number;
    offset: number;
    count: number;
    links:Array<BestStreetNameLink>;

    public static mergeJSON(instance: any, data: any): BestStreetName{
        if (!data) { return instance; }
        if (data.items != null) {
            instance.items = [];
            ([].concat(data.items)).forEach(occurrence => {
                instance.items.push(new BestStreetNameItem().fromJSON(occurrence)); // i3
            });
        }

        if (data.hasMore != null) {instance.hasMore = data.hasMore; }
        if (data.offset != null) {instance.offset = data.offset; }
        if (data.limit != null) {instance.limit = data.limit; }
        if (data.count != null) {instance.count = data.count; }
        if (data.links != null) {instance.links = data.links; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return BestStreetName.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: BestStreetName) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return BestStreetName.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: BestStreetName): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }
}

export class BestStreetNameItem{
    streetname: string;
    streetname_objectid: string;
    streetname_namespace: string;
    streetname_versionid: string;

    postal_info_objectid: string;
    postal_info_namespace: string;
    postal_info_versionid: string;

    municipality: string;
    municipality_namespace: string;
    municipality_objectid: string;
    municipality_versionid: string;

    part_of_municipality: string;
    part_of_municipality_namespace: string;
    part_of_municipality_objectid: string;
    part_of_municipality_versionid: string;

    addresses_street_complete_id: string;

    public static mergeJSON(instance: any, data: any): BestStreetNameItem {
        if (!data) { return instance; }


        if (data.streetname != null) { instance.streetname = data.streetname }
        if (data.streetname_objectid != null) {instance.streetname_objectid = data.streetname_objectid }
        if (data.streetname_namespace != null) {instance.streetname_namespace = data.streetname_namespace }
        if (data.streetname_versionid != null) {instance.streetname_versionid = data.streetname_versionid }

        if (data.postal_info_objectid != null) {instance.postal_info_objectid = data.postal_info_objectid }
        if (data.postal_info_namespace != null) {instance.postal_info_namespace = data.postal_info_namespace }
        if (data.postal_info_versionid != null) {instance.postal_info_versionid = data.postal_info_versionid }

        if (data.municipality != null) {instance.municipality = data.municipality }
        if (data.municipality_namespace != null) {instance.municipality_namespace = data.municipality_namespace }
        if (data.municipality_objectid != null) {instance.municipality_objectid = data.municipality_objectid }
        if (data.municipality_versionid != null) {instance.municipality_versionid = data.municipality_versionid }

        if (data.part_of_municipality != null) {instance.part_of_municipality = data.part_of_municipality }
        if (data.part_of_municipality_namespace != null) {instance.part_of_municipality_namespace = data.part_of_municipality_namespace }
        if (data.part_of_municipality_objectid != null) {instance.part_of_municipality_objectid = data.part_of_municipality_objectid }
        if (data.part_of_municipality_versionid != null) {instance.part_of_municipality_versionid = data.part_of_municipality_versionid }

        if(data.addresses_street_complete_id != null) {instance.addresses_street_complete_id = data.addresses_street_complete_id}

        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return BestStreetNameItem.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: BestStreetNameItem) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return BestStreetNameItem.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: BestStreetNameItem): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }
}

export class BestStreetNameLink{
    rel: string;
    href: string;
}

